module.exports = __webpack_public_path__ + "img/d-3.png";